var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 141,
    viewBox: "0 0 223 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 85.55L11.32 89.6H11.23L26.94 86.28L26.9 86.31L32.17 82.23",
    fill: "#3A3F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 85.55L11.32 89.6H11.23L26.94 86.28L26.9 86.31L32.17 82.23",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 85.5301L11.32 89.5801L11.23 89.6001L0.5 77.6401L5.49 62.3801L10.76 58.3101",
    fill: "#3A3F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 85.5301L11.32 89.5801L11.23 89.6001L0.5 77.6401L5.49 62.3801L10.76 58.3101",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.48 54.99L10.76 58.3L5.77002 73.57L16.5 85.52L32.22 82.21L37.21 66.94L26.48 54.99ZM23.27 77.81L23.29 77.84C19.1 78.84 14.9 76.25 13.9 72.06C13.12 68.77 14.55 65.47 17.22 63.73V63.68C21.41 62.68 25.61 65.27 26.61 69.46C27.39 72.76 25.96 76.06 23.27 77.81Z",
    fill: "#5964C6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4899 78.06C25.7978 78.06 29.2899 74.5678 29.2899 70.26C29.2899 65.9521 25.7978 62.46 21.4899 62.46C17.1821 62.46 13.6899 65.9521 13.6899 70.26C13.6899 74.5678 17.1821 78.06 21.4899 78.06Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1899 63.76C21.3799 62.76 25.6199 65.27 26.6199 69.46C27.3999 72.76 25.9699 76.0599 23.2799 77.8099L23.2999 77.8399C27.4899 76.8399 30.0799 72.6399 29.0799 68.4499C28.0799 64.2599 23.8799 61.67 19.6899 62.6699C18.7699 62.8899 17.9199 63.27 17.1699 63.76",
    fill: "#3A3F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1899 63.76C21.3799 62.76 25.6199 65.27 26.6199 69.46C27.3999 72.76 25.9699 76.0599 23.2799 77.8099L23.2999 77.8399C27.4899 76.8399 30.0799 72.6399 29.0799 68.4499C28.0799 64.2599 23.8799 61.6699 19.6899 62.6699C18.7699 62.8899 17.9199 63.27 17.1699 63.76",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67 73.6499L0.5 77.6999",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7097 47.43C89.1797 47.69 89.3297 47.64 89.1297 47.71C88.6997 47.87 88.6097 48.25 88.5597 48.74C88.5297 49.04 88.4497 49.34 88.3797 49.64C88.2797 50 87.9597 50.25 87.5797 50.26C86.3197 50.26 85.0697 50.26 83.8097 50.26C83.3297 50.26 83.0997 50.07 82.9897 49.59C82.8797 49.13 82.8097 48.66 82.6797 48.2C82.6397 48.05 82.4897 47.92 82.3697 47.82C82.2697 47.74 82.1297 47.64 82.0297 47.56C81.4597 47.15 80.9397 47.4 80.4497 47.82C80.2397 48 79.9797 48.13 79.7397 48.27C79.3697 48.49 79.0797 48.48 78.7697 48.18C77.8497 47.27 76.9297 46.36 76.0197 45.43C75.7297 45.13 75.7097 44.84 75.9397 44.46C76.1997 44.03 76.4897 43.62 76.7397 43.19C76.8097 43.07 76.7997 42.88 76.7797 42.73C76.7497 42.58 76.6597 42.43 76.5997 42.3C76.3197 41.71 76.0797 41.43 75.4897 41.38C75.1697 41.35 74.8497 41.25 74.5297 41.17C74.1597 41.08 73.9797 40.82 73.9697 40.45C73.9697 39.15 73.9697 37.86 73.9697 36.56C73.9697 36.13 74.1897 35.9 74.6597 35.79C75.1097 35.69 75.5697 35.61 76.0197 35.49C76.1697 35.45 76.3097 35.31 76.3997 35.18C76.4897 35.06 76.4897 34.87 76.5797 34.75C76.9697 34.22 76.8097 33.77 76.4397 33.32C76.2397 33.07 76.0897 32.79 75.9197 32.52C75.7097 32.18 75.7497 31.86 76.0197 31.58C76.9297 30.66 77.8397 29.74 78.7697 28.83C78.8397 28.76 78.9297 28.71 79.0297 28.66C79.1897 28.58 79.3697 28.58 79.5297 28.65C79.6197 28.69 79.7097 28.73 79.7997 28.78C80.2097 29.03 80.6097 29.28 80.9997 29.55C81.1797 29.67 81.3097 29.66 81.4997 29.57C81.7597 29.45 81.9097 29.39 82.0397 29.33C82.6297 29.05 82.9597 28.88 82.9597 28.54C82.9897 28.2 82.9597 27.66 83.0297 27.33C83.1197 26.96 83.3697 26.77 83.7497 26.77C85.0497 26.77 86.3397 26.77 87.6397 26.77C88.0797 26.77 88.3097 26.99 88.4097 27.46C88.5197 27.92 88.5897 28.39 88.7197 28.85C88.7597 28.99 88.8897 29.12 89.0197 29.2C89.1697 29.3 89.4597 29.48 89.7197 29.63C90.2197 29.9 90.4497 29.78 90.8697 29.43C91.1197 29.22 91.3697 28.93 91.6497 28.76C92.0397 28.53 92.3297 28.54 92.6497 28.85C93.5597 29.75 94.4697 30.66 95.3697 31.57C95.6797 31.88 95.6897 32.18 95.4497 32.57C95.1897 32.99 94.9097 33.4 94.6597 33.82C94.5897 33.94 94.5697 34.14 94.6097 34.26C94.7197 34.59 94.8497 34.91 95.0197 35.22C95.0797 35.34 95.2397 35.46 95.3697 35.49C95.8297 35.61 96.2997 35.69 96.7597 35.8C97.1597 35.89 97.4397 36.24 97.4397 36.65C97.4397 37.89 97.4397 39.12 97.4397 40.36C97.4397 40.77 97.1597 41.12 96.7597 41.22C96.2997 41.33 95.8297 41.4 95.3697 41.53C95.2297 41.57 95.1097 41.7 95.0097 41.82C94.9397 41.91 94.8297 42.08 94.7597 42.18C94.3297 42.78 94.5697 43.29 95.0297 43.81C95.2097 44.01 95.3197 44.26 95.4697 44.49C95.6797 44.82 95.6697 45.15 95.3897 45.43C94.4697 46.36 93.5497 47.29 92.6197 48.2C92.3397 48.47 92.0197 48.5 91.6797 48.29C91.2797 48.03 90.9897 47.78 90.5997 47.51C90.5997 47.51 90.2397 47.17 89.7197 47.42L89.7097 47.43ZM85.0197 43.74C88.4597 44.17 91.3397 41.27 90.8997 37.83C90.5997 35.49 88.6997 33.6 86.3597 33.31C82.9197 32.89 80.0397 35.78 80.4797 39.22C80.7797 41.56 82.6697 43.45 85.0197 43.74Z",
    fill: "#89422F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0398 49.0001C87.5098 49.2601 87.6598 49.2101 87.4598 49.2801C87.0298 49.4401 86.9398 49.8201 86.8898 50.3101C86.8598 50.6101 86.7798 50.9101 86.7098 51.2101C86.6098 51.5701 86.2898 51.8201 85.9098 51.8301C84.6498 51.8301 83.3998 51.8301 82.1398 51.8301C81.6598 51.8301 81.4298 51.6401 81.3198 51.1601C81.2098 50.7001 81.1398 50.2301 81.0098 49.7701C80.9698 49.6201 80.8198 49.4901 80.6998 49.3901C80.5998 49.3101 80.4598 49.2101 80.3598 49.1301C79.7898 48.7201 79.2698 48.9701 78.7798 49.3901C78.5698 49.5701 78.3098 49.7001 78.0698 49.8401C77.6998 50.0601 77.4098 50.0501 77.0998 49.7501C76.1798 48.8401 75.2598 47.9301 74.3498 47.0001C74.0598 46.7001 74.0398 46.4101 74.2698 46.0301C74.5298 45.6001 74.8198 45.1901 75.0698 44.7601C75.1398 44.6401 75.1298 44.4501 75.1098 44.3001C75.0798 44.1501 74.9898 44.0001 74.9298 43.8701C74.6498 43.2801 74.4098 43.0001 73.8198 42.9501C73.4998 42.9201 73.1798 42.8201 72.8598 42.7401C72.4898 42.6501 72.3098 42.3901 72.2998 42.0201C72.2998 40.7201 72.2998 39.4301 72.2998 38.1301C72.2998 37.7001 72.5198 37.4701 72.9898 37.3601C73.4398 37.2601 73.8998 37.1801 74.3498 37.0601C74.4998 37.0201 74.6398 36.8801 74.7298 36.7501C74.8198 36.6301 74.8198 36.4401 74.9098 36.3201C75.2998 35.7901 75.1398 35.3401 74.7698 34.8901C74.5698 34.6401 74.4198 34.3601 74.2498 34.0901C74.0398 33.7501 74.0798 33.4301 74.3498 33.1501C75.2598 32.2301 76.1698 31.3101 77.0998 30.4001C77.1698 30.3301 77.2598 30.2801 77.3598 30.2301C77.5198 30.1501 77.6998 30.1501 77.8598 30.2201C77.9498 30.2601 78.0398 30.3001 78.1298 30.3501C78.5398 30.6001 78.9398 30.8501 79.3298 31.1201C79.5098 31.2401 79.6398 31.2301 79.8298 31.1401C80.0898 31.0201 80.2398 30.9601 80.3698 30.9001C80.9598 30.6201 81.2898 30.4501 81.2898 30.1101C81.3198 29.7701 81.2898 29.2301 81.3598 28.9001C81.4498 28.5301 81.6998 28.3401 82.0798 28.3401C83.3798 28.3401 84.6698 28.3401 85.9698 28.3401C86.4098 28.3401 86.6398 28.5601 86.7398 29.0301C86.8498 29.4901 86.9198 29.9601 87.0498 30.4201C87.0898 30.5601 87.2198 30.6901 87.3498 30.7701C87.4998 30.8701 87.7898 31.0501 88.0498 31.2001C88.5498 31.4701 88.7798 31.3501 89.1998 31.0001C89.4498 30.7901 89.6998 30.5001 89.9798 30.3301C90.3698 30.1001 90.6598 30.1101 90.9798 30.4201C91.8898 31.3201 92.7998 32.2301 93.6998 33.1401C94.0098 33.4501 94.0198 33.7501 93.7798 34.1401C93.5198 34.5601 93.2398 34.9701 92.9898 35.3901C92.9198 35.5101 92.8998 35.7101 92.9398 35.8301C93.0498 36.1601 93.1798 36.4801 93.3498 36.7901C93.4098 36.9101 93.5698 37.0301 93.6998 37.0601C94.1598 37.1801 94.6298 37.2601 95.0898 37.3701C95.4898 37.4601 95.7698 37.8101 95.7698 38.2201C95.7698 39.4601 95.7698 40.6901 95.7698 41.9301C95.7698 42.3401 95.4898 42.6901 95.0898 42.7901C94.6298 42.9001 94.1598 42.9701 93.6998 43.1001C93.5598 43.1401 93.4398 43.2701 93.3398 43.3901C93.2698 43.4801 93.1598 43.6501 93.0898 43.7501C92.6598 44.3501 92.8998 44.8601 93.3598 45.3801C93.5398 45.5801 93.6498 45.8301 93.7998 46.0601C94.0098 46.3901 93.9998 46.7201 93.7198 47.0001C92.7998 47.9301 91.8798 48.8601 90.9498 49.7701C90.6698 50.0401 90.3498 50.0701 90.0098 49.8601C89.6098 49.6001 89.3198 49.3501 88.9298 49.0801C88.9298 49.0801 88.5698 48.7401 88.0498 48.9901L88.0398 49.0001ZM83.3498 45.3101C86.7898 45.7401 89.6698 42.8401 89.2298 39.4001C88.9298 37.0601 87.0298 35.1701 84.6898 34.8801C81.2498 34.4601 78.3698 37.3501 78.8098 40.7901C79.1098 43.1301 80.9998 45.0201 83.3498 45.3101Z",
    fill: "#F26241",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8999 33.49L95.5899 32.02",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.46 28.43L88.16 26.96",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4297 30.1599L79.1197 28.6899",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8496 35.77L74.2796 35.95L72.6196 37.5L74.3796 37.06C74.3796 37.06 74.6896 36.81 74.7196 36.77C74.7496 36.73 75.0696 36.04 75.0696 36.04L75.0996 35.72L74.8496 35.77Z",
    fill: "#89422F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2898 26.9299L81.7798 28.4099L83.7398 28.3499",
    fill: "#89422F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2898 26.9299L81.7798 28.4099L83.7398 28.3499",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2197 30.4501L88.8097 29.0601",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5098 36.9099L95.1998 35.4399",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5898 37.6499L97.2798 36.1799",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0298 44.3899L94.7198 42.9199",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9897 46.34L95.5397 44.99",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 49.1599L88.3 49.8999L86.73 51.2599L86.95 50.3099L87.08 49.5899L88.18 48.9399L88.54 48.9099L88.5 49.1599Z",
    fill: "#89422F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2098 40.9601L95.7598 42.2301V41.0801V40.3901",
    fill: "#89422F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2098 40.9601L95.7598 42.2301V41.0801V40.3901",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3296 34.8401L94.6496 33.8401",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1499 30.2201L92.2499 28.6401",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.87 30.89L222.36 37.89L191.49 45.27L198.26 73.58L175.75 46.66L153.26 62.59L166.97 38.46L138.44 25.05L169.97 26.53L169.83 0.5L182.41 23.55L206.67 4.85L194.87 30.89Z",
    fill: "#8ED943",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63 48.46H133.53V140.17H167.63V48.46Z",
    fill: "#3A3F74",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56 78.3501H82.46V140.17H116.56V78.3501Z",
    fill: "#5964C6",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4901 99.6699H31.3901V140.17H65.4901V99.6699Z",
    fill: "#39E1DD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222.86,
    height: 140.67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.e012e1f41c191e9849dc0337e917d37e.svg";
export { ForwardRef as ReactComponent };